import React from 'react';
import Asuntos from './Asuntos';
import Mensajes from './Mensajes';
//import Parametros from './Parametros';
import BaseUniverso from './BaseUniverso'
//import Modal from '../../comunes/Modal';
import { 
  faBullhorn
  , faEnvelopeOpenText
  //, faCrosshairs
  , faAddressBook
} from '@fortawesome/free-solid-svg-icons';

/* Links y Rutas Sidebar (Barra Vertical) */
export const ServicioNavTabs = [
  {
    title: 'Asunto',
    path: '#Asunto',
    icon: faBullhorn,
    cNameLi: 'nav-item',
    cNameA: 'nav-link active',
    dataToggle: 'tab'
  },
  {
    title: 'Mensaje',
    path: '#Mensaje',
    icon: faEnvelopeOpenText,
    cNameLi: 'nav-item',
    cNameA: 'nav-link',
    dataToggle: 'tab'
  },/*
  {
    title: 'Parámetros',
    path: '#Parametros',
    icon: faCrosshairs,
    cNameLi: 'nav-item',
    cNameA: 'nav-link',
    dataToggle: 'tab'
  }*/
  {
    title: 'Base de Prospección',
    path: '#Base_Universo',
    icon: faAddressBook,
    cNameLi: 'nav-item',
    cNameA: 'nav-link',
    dataToggle: 'tab'
  }
];

export const ServicioTabContent = [
    {
      id: 'Asunto',
      path: '#Asunto',
      component: <Asuntos />,
      cName: 'tab-pane fade active show',
    },
    {
      id: 'Mensaje',
      path: '#Mensaje',
      component: <Mensajes />,
      cName: 'tab-pane fade',
    }/*,
    {
      id: 'Parametros',
      path: '#Parametros',
      component: <Parametros />,
      cName: 'tab-pane fade',
    }*/,
    {
      id: 'Base_Universo',
      path: '#Base_Universo',
      component: <BaseUniverso />,
      cName: 'tab-pane fade',
    }
  ];